import React from 'react';

import { TypographyProps } from './Typography.types';
import { StyledTypography } from './Typography.styles';

const Typography = ({
  emphasis = 'regular',
  variant = 'body',
  size = 'md',
  color = 'default',
  ...rest
}: TypographyProps) => {
  return React.createElement(StyledTypography, {
    ...rest,
    emphasis,
    variant,
    color,
    size,
  });
};

export default Typography;
